/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { Link } from 'gatsby'
import { css } from '@emotion/react'

import DealsIcon from 'gatsby-theme-marketplace-base/src/assets/icons/deals.inline.svg'
import DevelopersIcon from 'gatsby-theme-marketplace-base/src/assets/icons/developer-console.inline.svg'
import { URLS } from 'gatsby-theme-marketplace-base/src/constants'

import Services from './Services'

const iconCss = css`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 12px 0 0;
  max-width: 20px;
  max-height: 20px;
`

const OtherSectionsLinks = () => (
  <ul className="list">
    <Services />

    <li>
      <Link to={URLS.DEVELOPERS.LINK} activeClassName="active-link">
        <span css={iconCss}>
          <DevelopersIcon />
        </span>
        <span>{URLS.DEVELOPERS.LABEL}</span>
      </Link>
    </li>
    <li>
      <Link to={URLS.SAAS_DEALS.LINK} activeClassName="active-link">
        <span css={iconCss}>
          <DealsIcon />
        </span>
        <span>{URLS.SAAS_DEALS.LABEL}</span>
      </Link>
    </li>
  </ul>
)

export default OtherSectionsLinks
